import './CustomPacingScheduleDrawer.scss';

import { bem } from 'mission-control-common-components';
import { useCallback } from 'react';

import Drawer from '../../../../common/Drawer';
import type { CustomPacingScheduleDrawerData } from '../../TraffickingPage/hooks/makePageDrawerPlugin';
import CustomPacingScheduleContent from './CustomPacingScheduleContent';

export type CustomPacingScheduleDrawerProps = {
  isOpen: boolean;
  data: CustomPacingScheduleDrawerData;
  onClose: () => void;
};

const [block] = bem('custom-pacing-schedule-drawer');

const CustomPacingScheduleDrawer = ({ isOpen, data, onClose }: CustomPacingScheduleDrawerProps): React.JSX.Element => {
  const renderContent = useCallback(
    (): React.JSX.Element => <CustomPacingScheduleContent lineItemIdList={data.lineItemIdList} onClose={onClose} />,
    [data.lineItemIdList, onClose]
  );

  return (
    <Drawer<CustomPacingScheduleDrawerData>
      data={data}
      content={renderContent}
      onClose={onClose}
      isOpen={isOpen}
      isExpanded={true}
      onToggleExpansion={(): void => {}}
      emptyHeader={true}
      className={block()}
    />
  );
};

export default CustomPacingScheduleDrawer;
